import React, { useState, useEffect, useRef } from 'react'
import './Style.css';
import { MdModeEditOutline } from 'react-icons/md'
import { Link, Navigate } from 'react-router-dom';
import SearchHead from './SearchHead';
import { useSelector, useDispatch } from 'react-redux';
import { orderActions } from '../_actions';
import { changeDateFormatFrench, convertNumberFrench } from '../_helpers';
import Layout from './Layout';
import PageLoaderComp from '../component/pageLoaderComp';
import { PageHeader, ResponsiveDataTable } from './Components';

export default function AnnoncesEnAttente() {
  const dispatch = useDispatch();
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [searchQuery, setSearchQuery] = useState('');

  const TabHead = [
    'Nom du client',
    'Formulaire',
    'Journal',
    'Montant ',
    'Date de création',
    'Action ',
    ' ',
  ];
  const [totalRows, setTotalRows] = useState([]);
  const [tabData, setTabData] = useState([]);
  const emptyRows =
    page > 0 ? Math.max(0, (1 + page) * rowsPerPage - tabData.length) : 0;

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const [pageLoading, setPageLoading] = useState(false);
  const currentUser = useSelector(state => state.authentication.user);

  const userData = (currentUser) => {
    // If user.data exists, use it; otherwise, use user directly
    return currentUser && currentUser.data ? currentUser.data : currentUser;
  };
  const user = userData(currentUser);
  const getAllDevise = () => {
    setPageLoading(true)
    dispatch(orderActions.getAll(user?.id, "order")).then((data) => {
      setPageLoading(false)
      setTabData(data);
 
      setTotalRows(data);
    })
      .catch(() => {
        setPageLoading(false)
      });
  }

  const getAllDeviseRef = useRef(getAllDevise);

  useEffect(() => {
    getAllDeviseRef.current();
   // console.log('getAllDevise',getAllDeviseRef.current());
  }, []);

  if (!currentUser) {
    return <Navigate to="/" />;
  }


/* 
  const filteredRows = tabData.filter((row) => {
    return Object.values(row).some((value) =>
      value.toString().toLowerCase().includes(searchQuery.toLowerCase())
    );
  }); */
  //console.log('datadata',JSON.parse(tabData[0]?.billing_address_json)?.billing_address_denomination);
  return (
    <>
     {pageLoading ?
      <PageLoaderComp />
      : ""}
    <Layout>
      <div className="mb-8 col-span-12 xl:col-span-9">
        <div className='xl:max-w-[1126px] w-full h-full bg-white rounded-[20px]'>
          <PageHeader title="Annonces en attente">
              <SearchHead setTotalRows={setTotalRows} totalRows={totalRows} setTabData={setTabData} />
          </PageHeader>
          
          <div className='mt-8 sm:px-9 px-4'>
            <ResponsiveDataTable
              columns={[
                {
                  header: 'Nom du client',
                  render: (item) => item?.billing_address_json ? JSON.parse(item?.billing_address_json)?.billing_address_denomination : item.username,
                },
                {
                  header: 'Formulaire',
                  field: 'form_type',
                  render: (item) => item.form_type,
                  truncate: true,
                },
                {
                  header: 'Journal',
                  field: 'journal_detail',
                  render: (item) => item.journal_detail,
                  truncate: true,
                },
                {
                  header: 'Montant',
                  render: (item) => <span className="font-semibold">{convertNumberFrench(item.total)} €</span>,
                },
                {
                  header: 'Date de création',
                  render: (item) => changeDateFormatFrench(item.creation_date),
                },
                {
                  header: 'Action',
                  isAction: true,
                  render: (item) => (
                    <Link 
                      to={`/nos-formulaires/${item.title}/${item.add_type === "modellibre" ? "modellibre" : item.form_type}/${item.id}`} 
                      className='text-base font-normal text-primary border border-primary rounded-full flex items-center justify-center w-9 h-9 hover:bg-secondary hover:border-secondary hover:text-white'
                    >
                      <MdModeEditOutline className='w-5 h-5' />
                    </Link>
                  ),
                },
              ]}
              data={tabData}
              page={page}
              rowsPerPage={rowsPerPage}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
              renderActions={(item) => (
                <Link 
                  to={`/nos-formulaires/${item.title}/${item.add_type === "modellibre" ? "modellibre" : item.form_type}/${item.id}`} 
                  className='text-base font-normal text-primary border border-primary rounded-full flex items-center justify-center w-9 h-9 hover:bg-secondary hover:border-secondary hover:text-white'
                >
                  <MdModeEditOutline className='w-5 h-5' />
                </Link>
              )}
              emptyMessage="Aucune annonce en attente"
              keyField="id"
            />
          </div>
        </div>
      </div>
    </Layout>
    </>
  )
}
